import styled from "styled-components";
import { Form } from "formik";
import { Modal } from "react-bootstrap";

export const ModalStyle = styled(Modal)`
  .modal-content {
    padding: 26px;
    border-radius: 10px;
    max-width: 500px;
    width: 100%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  span {
    color: ${({ theme }) => theme.colors.darkYellow};
    font-family: "Mangueira Bold";
    font-size: 1.25rem;
  }

  svg {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.darkYellow};
  }
`;

export const Title = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.darkYellow};
  font-family: "Mangueira Bold";
  font-size: 1.25rem;
`;

export const Container = styled.div`
  margin-top: 20px;

  h1 {
    margin-bottom: 20px;
  }
`;

export const ContentAlertIcon = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  svg {
    color: ${({ theme }) => theme.colors.darkYellow};
    width: 85px;
    height: 85px;
  }
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 0.9375rem;
  font-weight: 400;
  margin-bottom: 20px;
`;

export const Alert = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  p {
    margin: 0;
  }
`;

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FieldContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContainerButtons = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  button {
    width: 100%;
  }
  margin-top: 30px;
`;

export const ContainerText = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 10px;
`;

export const IconContainer = styled.div`
  border: 5px solid #f0b01b;
  width: 46px;
  height: 46px;
  border-radius: 100%;
  display: flex;
  place-content: center;
  place-items: center;
`;
